import { render } from "./CustomerSpecific .vue?vue&type=template&id=ec8a1220&scoped=true"
import script from "./CustomerSpecific .vue?vue&type=script&lang=js"
export * from "./CustomerSpecific .vue?vue&type=script&lang=js"

import "./CustomerSpecific .vue?vue&type=style&index=0&id=ec8a1220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8a1220"]])

export default __exports__